import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IUseMobileTopBottomColor {
  circadiaEngineProvider: ICircadiaEngineProvider;
}

export const useMobileTopBottomColor = ({
  circadiaEngineProvider,
}: IUseMobileTopBottomColor) => {
  const location = useLocation();
  useEffect(() => {
    // Function to update colors based on current hash
    const updateColors = () => {
      if (
        location.pathname.includes("otp") ||
        location.pathname.includes("otp-verification") ||
        location.pathname.includes("notification-settings") ||
        location.pathname.includes("floor-settings") ||
        location.pathname.includes("delete-account") ||
        location.pathname.includes("self-signup") ||
        location.pathname.includes("pending-activation") ||
        location.pathname.includes("device-intro") ||
        location.pathname.includes("get-started") ||
        location.pathname.includes("login")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#ebfdff", "#ebfdff");
      } else if (location.pathname.includes("ai-coach")) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
        console.log("location.pathname", location.pathname);
      } else if (
        location.pathname.includes("connect-device") ||
        location.pathname.includes("/setup/wifi") ||
        location.pathname.includes("device-manage") ||
        location.pathname.includes("terms-of-use") ||
        location.pathname.includes("privacyPolicy") ||
        location.pathname.includes("device-call") ||
        location.pathname.includes("device-assistant")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
      } else if (location.pathname === "/setup") {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#ffffff");
      } else {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#ffffff");
      }
    };
    updateColors();
  }, [location.pathname]);

  return null;
};
